import React from 'react';

const BackMatterContent = () => {
  return (
    <article className="prose prose-lg max-w-none">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">A Final Word to Every Reader</h1>
        <div className="flex justify-center gap-4 mt-4">
          <span className="text-2xl text-amber-600">✦</span>
          <span className="text-2xl text-amber-600">✦</span>
          <span className="text-2xl text-amber-600">✦</span>
        </div>
      </div>

      <div className="text-center my-12">
        <div className="bg-blue-50 border-2 border-blue-600 rounded-lg p-6 inline-block">
          <p className="text-blue-900 italic text-lg">
            "He who testifies to these things says, 'Surely I am coming quickly.'
          </p>
          <p className="text-blue-900 italic text-lg">
            Amen. Even so, come, Lord Jesus."
          </p>
          <p className="text-sm text-blue-700 font-semibold mt-2">— Revelation 22:20</p>
        </div>
      </div>

      <div className="text-center mb-12">
        <p className="text-3xl font-bold text-gray-900 mb-4">THE END</p>
        <p className="text-xl text-gray-600 italic">...and the beginning of everything.</p>
      </div>

      {/* The Main Points */}
      <div className="mt-16 mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">The Main Points of This Book</h2>
        
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-600 rounded-lg p-8 mb-8">
          <h3 className="text-2xl font-bold text-amber-900 mb-4">Overarching Thesis:</h3>
          <p className="text-gray-800 leading-relaxed">
            The Bible's own grammar and plain wording reveal that the gathering (Rapture) of believers will occur after the Great Tribulation, at the visible, last-trumpet return of Jesus Christ. The Grammar Integrity Test (GIT) is simply reading what Scripture says — no complicated theological system or Greek degree required.
          </p>
        </div>
      </div>

      <div className="text-center mt-16 mb-12">
        <p className="text-xl font-bold text-gray-900">The King's Return: The Legend and the Treasure Map That Was Stolen</p>
        <p className="text-gray-600 mt-2">Trump of the Lord Ministries — Curtis Alexander Fenison ("Mordecai")</p>
      </div>
    </article>
  );
};

export default BackMatterContent;
